import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Button } from 'components'

const ResignSuccess = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding center-cont">
				<i className="icon icon_check_circle" />
				<h3 className="intro-tit mt_20">회원탈퇴가 완료되었어요.</h3>
				<p className="intro-sub-tit mt_10">그동안 이용해주셔서 감사합니다.</p>
			</div>
			<div className="padding flex-shrink_0">
				<Button className="btn btn--big">확인</Button>
			</div>
		</div>
	)
}

export default ResignSuccess
